import { SmallGreyText } from '../../StyledComponents'
import { formattedExpDate } from '@/src/common/utilities/dateFormatters'
interface ShippingAndUsageContentProps {
    showPredesignMessage: boolean
}

const ShippingAndUsageContent = ({
    showPredesignMessage,
}: ShippingAndUsageContentProps) => {
    return (
        <>
            <p className={'build-message'}>
                {showPredesignMessage
                    ? 'Choose a trendy card design fit for any occasion.'
                    : 'Build a personalized gift card with a photo.'}{' '}
                <span className={'bold'}>Printed and shipped same-day</span> for
                orders placed by 4pm ET (Mon-Sat).
            </p>
            <SmallGreyText>
                Images subject to review in accordance with our image
                guidelines. For use in US only. If purchased today the card will
                expire on {formattedExpDate()}.  However, the funds do not
                expire.
            </SmallGreyText>
        </>
    )
}

export default ShippingAndUsageContent
